import axios from 'axios'
import Cookie from 'js-cookie'

const extractPagination = ({ headers }) => {
  if (!headers['x-page']) { return null }
  return {
    nextPage: parseInt(headers['x-next-page'], 10),
    offset: parseInt(headers['x-offset'], 10),
    page: parseInt(headers['x-page'], 10),
    perPage: parseInt(headers['x-per-page'], 10),
    total: parseInt(headers['x-total'], 10),
    totalPages: parseInt(headers['x-total-pages'], 10)
  }
}

const authorization = () => {
  const token = Cookie.getJSON('authorization') || {}
  const result = {}
  const authorization = [token.token_type, token.access_token].filter(e => e).join(' ')
  const platformToken = token.platform_token
  if (authorization) { result.Authorization = authorization }
  if (platformToken) { result.PlatformToken = platformToken }
  return result
}

const factory = (baseURL = endpoint(process.env.API_ENDPOINT_PREFIX)) => {
  const instance = axios.create({
    baseURL,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  instance.interceptors.request.use(
    config => {
      return {
        ...config,
        headers: {
          ...config.headers,
          ...authorization()
        }
      }
    },
    error => Promise.reject(error)
  )
  instance.interceptors.response.use(
    response => ({ ...response, pagination: extractPagination(response) }),
    error => Promise.reject(error)
  )
  return instance
}

export const endpoint = (prefix, { protocol = 'https' } = { protocol: 'https' }) => `${protocol}://${prefix}.${process.env.ENDPOINT}`

export default factory



// WEBPACK FOOTER //
// ./src/utils/http.js